import { render, staticRenderFns } from "./UserManagementAdd.vue?vue&type=template&id=331dc782&scoped=true"
import script from "./UserManagementAdd.vue?vue&type=script&lang=js"
export * from "./UserManagementAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "331dc782",
  null
  
)

export default component.exports